unable to read source [project]/frontend/node_modules/src/zxing-html5-qrcode-decoder.ts